module.exports = __webpack_public_path__ + "static/media/jpa.652e87c9.png";